export function removeLeadingHashtagFromNavigationHashIfNeeded(hash: string): string {
    if (hash.startsWith('#')) {
        return hash.split('#')[1];
    }
    return hash;
}
